import React, {Component} from 'react';
import Loader from "react-loader";
import ArtifactDialog from "./ArtifactDialog";
import {Parser} from 'html-to-react';


class DiscussionRender extends Component {
    htmlToReactParser = new Parser();
    constructor(props) {
        super(props);
        this.state = {
            loaded: true
        };
    }

    renderDescription() {
        return (
            <div>
                <h1>{this.props.submission.canvas_assignment_name}</h1>
                <hr/>
                <h2>Assignment Description</h2>
                <h3>
                    {this.htmlToReactParser.parse(this.props.submission.canvas_assignment_description.replace(/(\\r\\n|\\n|\\r)/gm," "))}
                </h3>
                <hr/>

            </div>
        );
    }

    renderDiscussionThread() {
        return(
            <div>
                {this.htmlToReactParser.parse(this.props.submission.body.replace(/(\\r\\n|\\n|\\r)/gm," "))}
            </div>
        )
    }

    renderReplies(){
        if(this.props.submission.replies){
            return this.props.submission.replies.map(reply=>{
                return <div>
                    {this.htmlToReactParser.parse(reply.message.replace(/(\\r\\n|\\n|\\r)/gm," "))}
                </div>
            })
        }
    }

    render() {
        return (
            <ArtifactDialog title="Discussion Artifact" isReviewed={this.props.isReviewed} submission={this.props.submission}>
                <div>{this.renderDescription()}</div>
                <div>{this.renderDiscussionThread()}</div>
                {this.props.submission.replies?<div>Replies</div>:null}
                <div>{this.renderReplies()}</div>
                <Loader loaded={this.state.loaded}/>
            </ArtifactDialog>
        )
    }
}

export default DiscussionRender;

